var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.2,
    height: 79.2,
    viewBox: "0 0 79.2 79.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orion_set-square",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M3.4,79.6H79.6V3.4L3.4,79.6Z",
    transform: "translate(-3.4 -3.4)",
    fill: "none",
    stroke: "#e0a403",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer2-2",
    "data-name": "layer2",
    d: "M11.4,61.236H46.036V26.6Z",
    transform: "translate(19.506 4.306)",
    fill: "none",
    stroke: "#e0a403",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M65.351,16.863,61.088,12.6M56.825,25.522l-4.4-4.263M48.166,34.048,43.9,29.785m-4.4,12.922-4.263-4.263m-4.4,12.922L26.585,47.1M22.322,60.025l-4.263-4.4m-4.4,12.922L9.4,64.288",
    transform: "translate(2.856 -0.344)",
    fill: "none",
    stroke: "#c3001b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWork);
export default __webpack_public_path__ + "static/media/icon-work.19d223f7188510d2d8fbc1400183d41d.svg";
export { ForwardRef as ReactComponent };